module.exports = __webpack_public_path__ + "img/error.3bbc0e46.jpg";